import React, { useState } from 'react';
import JobTile from '../JobTile/JobTile';
import { Layout } from '../Layout/Layout';
import Loader from '../Loader/Loader';

export default function JobResponded() {

    return (
        <>
        <Layout>
            <JobTile title="Client Responded Jobs" type="4" isStared="0" clientRespondedOn="1" />
        </Layout>
        </>
    )
}